<template>
  <transition name="app-slide-panel">
    <div v-if="active" class="app-slide-panel-backdrop" @click.self="close">
      <div tabindex="-1" :class="['app-slide-panel dark:bg-gray-800', panelPosition]">
        <div
          class="btn btn-icon-only justify-center p-0 absolute right-0 top-0 cursor-pointer"
          @click="close">
          <i class="far fa-times text-2xl text-gray-500" />
        </div>
        <Suspense>
          <component
            :is="viewComponent"
            v-if="viewComponent"
            v-bind="viewProps"
            v-on="viewEvents"
            @on-close-panel="close"
            @on-editing="onEditing" />
        </Suspense>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, markRaw } from 'vue'
import { confirmAlert } from '~/javascript/utils/confirm_alert'

const active = ref(false)
const panelPosition = ref('right')
const viewComponent = ref(null)
const viewProps = ref(null)
const viewEvents = ref(null)
const isEditing = ref(false)
const panelTextConfirmation = ref('')

const onEsc = (event) => {
  if (event.key === 'Escape') {
    close() // eslint-disable-line no-use-before-define
  }
}

const open = ({
  component,
  props = {},
  events = {},
  position = 'right',
  textConfirmation = ''
}) => {
  active.value = true
  viewComponent.value = markRaw(component)
  viewProps.value = props
  viewEvents.value = events
  panelPosition.value = position
  panelTextConfirmation.value = textConfirmation

  window.addEventListener('keydown', onEsc)
  document.body.classList.add('overflow-hidden')
}

const onClose = () => {
  active.value = false
  isEditing.value = false

  viewComponent.value = null
  viewProps.value = null
  viewEvents.value = null

  window.removeEventListener('keydown', onEsc)
  document.body.classList.remove('overflow-hidden')
}

const close = async() => {
  if (isEditing.value) {
    if (await confirmAlert({ text: panelTextConfirmation.value })) {
      onClose()
    }
  } else {
    onClose()
  }
}

const onEditing = (bool) => {
  isEditing.value = bool
}

defineExpose({ open, close })
</script>
